<template>
  <div>
    <Row :gutter="4">
      <div v-if="companyIdCookie == 1">
        <Col span="4">
          <Select
            v-model="companyId"
            filterable
            :placeholder="$t('schedule_instance_config.selectByCompany')"
            :transfer="true"
          >
            <Option
              :value="item.id"
              v-for="item in companyList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </Col>
      </div>
      <Col span="4">
        <!-- v-on:input实时查询 -->
        <Input
          search
          v-model="serverSearchKey"
          :placeholder="$t('schedule_instance_config.selectByIp')"
        />
      </Col>
      <Col span="4">
        <Select v-model="awsResourceType" placeholder="">
          <Option
            v-for="item in isAwsResourceType"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </Col>
      <Col span="4">
        <Button
          type="info"
          @click="show"
          v-hasPermission="['timerSwitchs:serverSearchs:task_search']"
          >{{ $t("alarms.common.search") }}
        </Button>
        <Button
          type="warning"
          :loading="modal_loading"
          @click="exportServerSearchs"
          v-hasPermission="['timerSwitchs:serverSearchs:export']"
          >{{ $t("common.export") }}
        </Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import TableServerTaskSearchs from "../server_searchs/TableServerTaskSearchs";
import { getCookie } from "../../../utils/cookieUtil.js";
import utils from "../../../utils/utils.js";

var tableServerTaskSearchs = TableServerTaskSearchs;

var ServerTaskSearchsSearch = {};
export default {
  name: "ServerTaskSearchsSearch",
  components: {
    TableServerTaskSearchs
  },
  data() {
    return {
      companyIdCookie: getCookie(global.companyId),
      showCheckbox: false,
      showExport: false,
      modal_loading: false,
      serverSearchKey: "",
      single: false,
      awsResourceType: 0,
      companyId: "",
      companyList: [],
      isAwsResourceType: [
        {
          id: 0,
          name: this.$t("schedule_instance_config.virtualHost")
        },
        {
          id: 7,
          name: this.$t("schedule_instance_config.virtualDesktop")
        }
      ]
    };
  },
  beforeCreate: function() {
    ServerTaskSearchsSearch = this;
  },
  mounted() {
    this.getCompanyDropDownBox();
  },
  methods: {
    show: function() {
      tableServerTaskSearchs.methods.showAll(
        this.serverSearchKey,
        this.single,
        this.awsResourceType,
        this.companyId
      );
    },
    // 获取公司下拉框
    getCompanyDropDownBox: function() {
      this.$api.company
        .getCompanyDropDownBox("userName", getCookie(global.cookieName))
        .then(res => {
          this.companyList = res.data;
        });
    },
    //导出
    exportServerSearchs: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t('common.exporting')
      });
      // 下载Excel 文件
      this.$api.instance
        .exportInstanceTask({
          pageNum: 1,
          hasTask: this.single,
          maxResult: 15,
          privateIp: this.serverSearchKey,
          awsResourceType: this.awsResourceType
        })
        .then(res => {
          let fileName = "InstanceTask.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success(this.$t('common.exportSuccess'));
        });
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/timer_switchs/server_searchs/ServerTaskSearchsSearch.vue